<template>
  <iframe
    :src="src"
    style="width:100%;height:100%;border:none"
  ></iframe>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Tacho',
  computed: {
    ...mapGetters(['user']),
    src() {
      const tacho = this.user && this.user.attributes && this.user.attributes.tacho
      return typeof tacho === 'string' && tacho.startsWith('http') ? tacho : '/reports/tacho/'
    }
  }
}
</script>
